


























import { Component, Vue, Watch } from "vue-property-decorator";
import { Action, Getter } from "vuex-class";
import { GetValidationRules, AppActionTypes } from "./store";
import { IRouteConfigMeta, IRouteConfig } from "./router";
import { errorLog } from "./logging";
import { IUserModel } from "./models";

@Component
export default class App extends Vue {
    @Action(AppActionTypes.getValidationRules)
    getValidationRules!: GetValidationRules;

    @Getter
    version!: string;

    @Getter
    environmentAlert!: string;

    @Getter
    user: IUserModel | undefined;

    loading = true;
    copyrightDate = new Date().getFullYear();

    get breadcrumbs(): Array<{
        text: string;
        to: IRouteConfig;
        active: boolean;
    }> {
        const routeMeta: IRouteConfigMeta = this.$route.meta;
        const currentRoute = this.$route as IRouteConfig;

        const routes: IRouteConfig[] =
            // clone the meta breadcrumbs if we have any
            routeMeta && routeMeta.breadcrumbs
                ? [...routeMeta.breadcrumbs]
                : [];
        if (!routes.find(r => r.path === currentRoute.path)) {
            routes.push(currentRoute);
        }
        return routes
            .filter(route => route.meta && route.meta.title)
            .map(route => ({
                text: route.meta && route.meta.title ? route.meta.title : "",
                to: route,
                active: this.$route.path === route.path
            }));
    }

    mounted() {
        this.getValidationRules().then(() => {
            this.loading = false;
        });
    }

    @Watch("user")
    userChanged() {
        if (this.user) {
            errorLog.setUser({
                identifier: (this.user.id || 0).toString(),
                email: this.user.emailAddress || undefined,
                firstName: this.user.firstName || undefined,
                fullName: this.user.firstName + " " + this.user.lastName,
                isAnonymous: false
            });
        }
    }
}
